import { render, staticRenderFns } from "./translateProfileForm.vue?vue&type=template&id=18553414&"
import script from "./translateProfileForm.vue?vue&type=script&lang=js&"
export * from "./translateProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./translateProfileForm.vue?vue&type=style&index=0&id=18553414&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports